import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { EmptyState } from '@/components/ui/EmptyState';
import { Button } from '@/components/ui/Button';

/**
 * Elegant scaffold for not-yet-implemented modules.
 * Keeps the premium feel while features are built phase by phase (see ROADMAP.md).
 */
export function ModulePage({ titleKey, icon }: { titleKey: string; icon?: React.ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-7xl space-y-6 pt-2">
      <motion.h1
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        className="font-display text-2xl font-bold sm:text-3xl"
      >
        {t(titleKey)}
      </motion.h1>
      <EmptyState
        icon={icon}
        title={t('empty.title')}
        subtitle={t('empty.subtitle')}
        action={<Button>{t('empty.cta')}</Button>}
      />
    </div>
  );
}
